import React from 'react';

/**
 * AdminPageHeader — the ONE shared page header so every admin tab's title/tagline
 * looks identical to the Dashboard standard:
 *   eyebrow (Cormorant, uppercase, wide tracking)
 *   → Playfair title (34)
 *   → Cormorant tagline (14)
 *   → thin gold-gradient divider.
 * Values copied verbatim from the Dashboard header (the reference), so adopting this
 * across tabs is a pure consistency change — no new look invented.
 */

const FONT_PLAYFAIR = "'Playfair Display', serif";
const FONT_CORMORANT = "'Cormorant Garamond', serif";
const GOLD_DIVIDER = 'linear-gradient(90deg, #D4AF37 0%, #F5D061 30%, rgba(212,175,55,0.3) 60%, transparent 100%)';

export default function AdminPageHeader({ eyebrow, title, tagline, right = null, style = {}, onDark = false }) {
  // onDark: the host surface is dark (e.g. the Communications Intelligence black design), so the
  // eyebrow / title / tagline switch to readable light tones. Default (false) keeps the white-app
  // colors verbatim — no other tab is affected.
  const eyebrowColor = onDark ? '#FFFFFF' : '#444444';
  const titleColor = onDark ? '#E6C579' : '#1a1a1a';
  const taglineColor = onDark ? '#FFFFFF' : '#444444';
  return (
    <div style={{ position: 'relative', zIndex: 1, marginBottom: 18, ...style }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ minWidth: 0 }}>
          {eyebrow ? (
            <span style={{ fontFamily: FONT_CORMORANT, fontWeight: 700, fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.25em', color: eyebrowColor, display: 'block', marginBottom: 4 }}>
              {eyebrow}
            </span>
          ) : null}
          <h1 style={{ fontFamily: FONT_PLAYFAIR, fontWeight: 700, fontSize: 34, color: titleColor, margin: 0, lineHeight: 1.1, letterSpacing: '-0.01em' }}>
            {title}
          </h1>
          {tagline ? (
            <p style={{ fontFamily: FONT_CORMORANT, fontWeight: 600, fontSize: 14, color: taglineColor, margin: '4px 0 0' }}>
              {tagline}
            </p>
          ) : null}
        </div>
        {right ? <div style={{ flex: 'none' }}>{right}</div> : null}
      </div>
      <div style={{ height: 2, background: GOLD_DIVIDER, marginTop: 16, boxShadow: '0 1px 4px rgba(212,175,55,0.2)' }} />
    </div>
  );
}
